export const clearCooldownTimer = (timerRef) => {
	if (timerRef?.current) {
		clearInterval(timerRef.current);
		timerRef.current = null;
	}
};

export const startCooldownTimer = ({
	remaining,
	defaultSeconds,
	setCooldown,
	timerRef,
	endAtRef,
}) => {
	const seconds = Number.isFinite(remaining) && remaining > 0 ? remaining : defaultSeconds;
	const now = Date.now();
	endAtRef.current = now + seconds * 1000;

	const tick = () => {
		const msLeft = endAtRef.current - Date.now();
		const secondsLeft = Math.max(0, Math.ceil(msLeft / 1000));
		setCooldown(secondsLeft);

		if (secondsLeft <= 0) {
			clearCooldownTimer(timerRef);
		}
	};

	clearCooldownTimer(timerRef);
	tick();
	timerRef.current = setInterval(tick, 250);
};
